import { render, staticRenderFns } from "./PaginationButton.vue?vue&type=template&id=29e0e9ab&"
import script from "./PaginationButton.vue?vue&type=script&lang=js&"
export * from "./PaginationButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports